export default "__VITE_ASSET__BH2RLrRu__"